"use client";

import {
  ArchitectureThemeMapped,
  EcosystemeThemeMapped,
} from "@/app/types/new/project";
import { Accordion } from "@mantine/core";

import Link from "next/link";
import { usePathname, useSearchParams } from "next/navigation";
import CustomBlocksRenderer from "./custom-block-renderer";

export default function ProjectPageHeader({
  ecosystemeThemes,
  architectureThemes,
  isMapPage,
}: {
  ecosystemeThemes: EcosystemeThemeMapped[] | null;
  architectureThemes: ArchitectureThemeMapped[] | null;
  isMapPage?: boolean;
}) {
  const pathname = usePathname();
  const getCurrentFilter = (
    filteredBy: string
  ): EcosystemeThemeMapped | ArchitectureThemeMapped | null => {
    if (filteredBy) {
      const [key, value] = filteredBy.split("=");
      if (key === "architecture") {
        return (
          architectureThemes?.find((theme) => theme.slug === value) || null
        );
      } else if (key === "ecosysteme") {
        return ecosystemeThemes?.find((theme) => theme.slug === value) || null;
      }
    }
    return null;
  };
  const searchParams = useSearchParams();
  let filteredBy = "";
  searchParams.forEach((value, key) => {
    filteredBy += `${key}=${value}`;
  });

  const currentFilter = getCurrentFilter(filteredBy);
  return (
    <aside className="page-top">
      <div className="container no-padding">
        <div className="project-header-container">
          <nav className="projects-nav">
            <Link
              className={pathname === "/projets" ? "selected" : ""}
              href={`/projets${currentFilter ? `?${filteredBy}` : ""}`}
            >
              Chronologie
            </Link>
            <Link
              className={pathname === "/map" ? "selected" : ""}
              href={`/map${currentFilter ? `?${filteredBy}` : ""}`}
            >
              Carte
            </Link>
          </nav>
          <div
            className={`project-filter-container ${
              currentFilter ? "" : "two-cols"
            }`}
          >
            {currentFilter ? (
              <div className="with-filter">
                <h3>{currentFilter.name}</h3>
                {currentFilter.description ? (
                  <CustomBlocksRenderer content={currentFilter.description} />
                ) : null}
                <Link href={`/${isMapPage ? "map" : "projets"}`}>
                  Tous les projets
                </Link>
              </div>
            ) : (
              <>
                <div>
                  <h3>Architecture</h3>
                  {architectureThemes?.map((theme) => (
                    <div key={theme.id}>
                      <Link
                        href={`/${isMapPage ? "map" : "projets"}?architecture=${
                          theme.slug
                        }`}
                        className={
                          filteredBy === `architecture=${theme.slug}`
                            ? "selected"
                            : ""
                        }
                      >
                        {theme.name}
                      </Link>
                    </div>
                  ))}
                </div>
                <div>
                  <h3>Écosystèmes</h3>
                  {ecosystemeThemes?.map((theme) => (
                    <div key={theme.id}>
                      <Link
                        href={`/${isMapPage ? "map" : "projets"}?ecosysteme=${
                          theme.slug
                        }`}
                        className={
                          filteredBy === `ecosysteme=${theme.slug}`
                            ? "selected"
                            : ""
                        }
                      >
                        {theme.name}
                      </Link>
                    </div>
                  ))}
                </div>
              </>
            )}
          </div>
          <div className="project-filter-container-mobile">
            {currentFilter ? (
              <div className="with-filter">
                <h3>{currentFilter.name}</h3>
                {currentFilter.description ? (
                  <CustomBlocksRenderer content={currentFilter.description} />
                ) : null}
                <Link href={`/${isMapPage ? "map" : "projets"}`}>
                  Tous les projets
                </Link>
              </div>
            ) : (
              <Accordion
                disableChevronRotation
                chevron={<div className="custom-chevron" />}
                className="accordion themes-accordion"
              >
                <Accordion.Item value="architecture">
                  <Accordion.Control className="line-title">
                    <div className="line-grid">
                      <div className="title">Architectures</div>
                    </div>
                  </Accordion.Control>
                  <Accordion.Panel>
                    {architectureThemes?.map((theme) => (
                      <div key={theme.id}>
                        <Link
                          href={`/${
                            isMapPage ? "map" : "projets"
                          }?architecture=${theme.slug}`}
                          className={
                            filteredBy === `architecture=${theme.slug}`
                              ? "selected"
                              : ""
                          }
                        >
                          {theme.name}
                        </Link>
                      </div>
                    ))}
                  </Accordion.Panel>
                </Accordion.Item>
                <Accordion.Item value="ecosysteme">
                  <Accordion.Control className="line-title">
                    <div className="line-grid">
                      <div className="title">Ecosystèmes</div>
                    </div>
                  </Accordion.Control>
                  <Accordion.Panel>
                    {ecosystemeThemes?.map((theme) => (
                      <div key={theme.id}>
                        <Link
                          href={`/${isMapPage ? "map" : "projets"}?ecosysteme=${
                            theme.slug
                          }`}
                          className={
                            filteredBy === `ecosysteme=${theme.slug}`
                              ? "selected"
                              : ""
                          }
                        >
                          {theme.name}
                        </Link>
                      </div>
                    ))}
                  </Accordion.Panel>
                </Accordion.Item>
              </Accordion>
            )}
          </div>
        </div>
      </div>
    </aside>
  );
}
